const initialState = {
    events: [],
    pagination: {
        current_page: 1,
        per_page: 30,
        total: 0,
        last_page: 1,
    },
    counts: {
        pending: 0,
    },
    fetching: false,
    fetched: false,
    error: null,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'FETCH_GITLAB_EVENTS_PENDING': {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: null,
            };
        }
        case 'FETCH_GITLAB_EVENTS_FULFILLED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                events: action.payload.data || [],
                pagination: action.payload.pagination || state.pagination,
                counts: action.payload.counts || state.counts,
            };
        }
        case 'FETCH_GITLAB_EVENTS_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.payload,
            };
        }
        case 'CLEAR_GITLAB_EVENTS': {
            return initialState;
        }
        default:
            return state;
    }
}
